<script>
import baseList from "@/views/components/base/baseList.vue";
import { Tag, Button } from "view-design";
import Vue from "vue";
// import Info from "./info.vue";
import Check from "../check.vue";
// import Track from './track.vue'
export default {
  extends: baseList,
  components: {
    Check,
  },
  data() {
    return {
      table: {
        mname: "patrol",
        key: "id",
        url: {
          list: "/admin/system/patrol/list?onlySceneState=2",
          del: "/admin/system/patrol",
        },
        output: false,
        order: "createTime",
      },
      query: {
        onlySceneState: 2,
      },
      actions: [],
      menus: [
        {
          label: "盘点纪录",
          name: "inventory_record_list",
          auth: "system/inventoryRecordList/index",
        },
        {
          label: "主动巡检",
          name: "active_inspection_list",
          auth: "system/activeInspectionList/index",
        },
        {
          label: "定时巡检",
          name: "inspection_list",
          auth: "system/inspection/index",
        },
      ],
      filters: [
        {
          label: "负责人",
          KeyEnter: this.search,
          name: "maintainerId",
          value: "",
          type: "select",
          dropList: [],
        },
        {
          label: "巡检时间",
          KeyEnter: this.search,
          name: "",
          value: "",
          type: "contractdatetimerange",
        },
        {
          label: "巡检单号",
          KeyEnter: this.search,
          name: "id",
          value: "",
          type: "input",
        },
      ],
      tableCols: [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center",
        },
        {
          title: "巡检单号",
          width: 120,
          align: "center",
          key: "id",
        },
        {
          title: "巡检设备",
          width: 200,
          align: "left",
          key: "facilityListName",
          render: (h, params) => {
            const row = params.row;
            const text = row.facilityListName;
            return <span>{text}</span>;
          },
        },
        {
          title: "巡检内容",
          minWidth: 200,
          align: "left",
          key: "patrolContent",
          render: (h, params) => {
            const row = params.row;
            const text = row.patrolContent;
            return <span>{text}</span>;
          },
        },
        {
          title: "巡检凭证",
          width: 120,
          align: "center",
          key: "imgUrl",
          viewimage: true,
        },
        {
          title: "异常情况",
          width: 120,
          align: "center",
          key: "facilityState",
          render: (h, params) => {
            const row = params.row;
            const text = row.facilityState == 2 ? "正常" : "异常";
            return <span>{text}</span>;
          },
        },
        {
          title: "负责人",
          key: "name",
          width: 120,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.name;
            return (
              <span
                style={{
                  color: row.state == 1 ? "red" : "",
                }}
              >
                {text}
              </span>
            );
          },
        },
        {
          title: "巡检时间",
          width: 180,
          align: "center",
          key: "createTime",
          render: (h, params) => {
            const row = params.row;
            const text = row.createTime.slice(0, 16);
            return <span>{text}</span>;
          },
        },
      ],
    };
  },
  created() {
    this.loaduserData();
  },
  methods: {
    //查询维修员
    loaduserData() {
      // 通过pk查询字典数据
      let q = {};
      $utils.api.load("/admin/system/maiUser/lista", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.nickName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.filters.length; index++) {
            const element = this.filters[index];
            if (element && element.name == "maintainerId") {
              // this.items[index]['dropList'] = dropList
              this.filters[index]["dropList"] = (
                this.filters[index]["dropList"] || []
              ).concat(dropList);
            }
          }
        }
      });
    },
    toCheck(row) {
      this.$Modal.success({
        closable: true,
        title: "巡检记录",
        width: "1000px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <Check
              style={{ margin: "0", color: "#19be6b" }}
              planId={row.id}
            ></Check>
          );
        },
      });
    },
    toAdd() {
      $utils.url.push({ name: "inspection_add", query: { action: "add" } });
    },
    //  handleEdit(currentRow){
    //   $utils.url.push({ name: "inspection_edit", query: {action: "edit", kv: currentRow.id } });
    // },
    //详情
    toinfo(row) {
      $utils.url.push({
        name: "inspection_info",
        query: { action: "edit", kv: row.id, planId: row.id },
      });
    },
    // //导出
    // toImport() {},
    // //下载模板
    // toDownload() {},
  },
};
</script>
<style scoped></style>
